import React, {Component} from 'react';
import {connect} from 'react-redux';
import VariablesForm from '../components/VariablesForm';
import {DATA_SETS, FFM_OPTION} from '../Constants';
import './Forms.css';

const META_DATA = [
  { key: 'overstorey_cover', displayName: 'Overstorey Cover (%)', min: 0, max: 100, row: 1, order: 1 },
  { key: 'fine_fuel_load', displayName: 'Combined Surface Fine Fuel Load (t/ha)', min: 0, max: 50, row: 1, order: 3 },
  { key: 'overstorey_height', displayName: 'Overstorey Height (m)', min: 0, max: 20, row: 2, order: 2 },
  {
    key: 'ffm_option', displayName: 'SFFM Option', row: 2, order: 4,
    enum: { 'Matthews Mallee': FFM_OPTION.MALLEE, 'Matthews Heath': FFM_OPTION.HEATH }
  },
  {
    key: 'lag_temp_rh', displayName: 'Lag Temp & RH', row: 3, order: 5,
    enum: { 'Off': 0, '2 Hrs': 2 }
  }
];

class MalleeHeathVariables extends Component {
  render() {
    return <VariablesForm data_set={DATA_SETS.MALLEE_HEATH}
                          meta_data={META_DATA}
                          variables={this.props.variables}
                          dispatch={this.props.dispatch}/>;
  }
}

const mapStateToProps = state => {
  return {
    variables: {
      overstorey_cover: state.point_data_mallee_heath.overstorey_cover,
      overstorey_height: state.point_data_mallee_heath.overstorey_height,
      fine_fuel_load: state.point_data_mallee_heath.fine_fuel_load,
      lag_temp_rh: state.point_data_mallee_heath.lag_temp_rh,
      ffm_option: state.point_data_mallee_heath.ffm_option
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MalleeHeathVariables);



// WEBPACK FOOTER //
// ./src/containers/MalleeHeathVariables.js